import ConversationEffect from "src/Animations/ConversationEffect";
import setCurrentPage from "src/Utils/setCurrentPage";

export const DATA_AI_POWERED_DOC_INLCM_2 = {
  title:
    "Uploaded documents are converted \nas text to be embedded and stored \nin the knowledge repository.",
  subtitle: "Gen AI powered network design",
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ENG_309"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ENG_307"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ENG/INLCM/INLCM_dark_bg_1.png",
  rightSideComponent: (
    <ConversationEffect
      images={[
        {
          image: "ENG/INLCM/INLCM_ai_powered_01_computer.png",
          effect: "animate-opacity",
          imageStyle: { position: "absolute", bottom: "170px", right: "0px" },
        },
        {
          image: "ENG/INLCM/INLCM_ai_powered_02_screen.png",
          imageStyle: { position: "absolute", bottom: "236px", right: "63px" },
        },
        {
          image: "ENG/INLCM/INLCM_ai_powered_02_network.png",
          imageStyle: { position: "absolute", bottom: "71px", right: "193px" },
        },
      ]}
      pageNumber={"ENG_308"}
    />
  ),
};
